// ** Third Party Import
import { useTranslation } from 'react-i18next'

const Translations = ({ text }) => {
  // ** Hook
  const { t } = useTranslation()

  // eslint-disable-next-line react/react-in-jsx-scope
  return <>{`${t(text)}`}</>
}

export default Translations
